module.exports = __webpack_public_path__ + "static/media/mail-box.319f2ffd.png";